const soldPropertyStore = {
  namespaced: true,
  state: {
    properties: [
      {
        id: '818S2ndAveArcadia',
        sold: true,
        title: '818 S. 2nd Ave., #B, Arcadia, CA 91006',
        price: '898000',
        soldDate: '2018-06-12',
        soldPrice: '917000',
        bedroom: '3',
        bathroom: '3',
        livingArea: '2064',
        lotSize: '',
        yearBuild: '2002',
        pics: ['00_Front.jpg','01_Living_room_4.jpg','01_Living_room_Dining_room_1.jpg','03_Den_Downstatis.jpg','04_Kitchen_1.jpg','06_Upstairs_loft.jpg','07_Master_bedroom.jpg',
          '07_Master_bedroom_Walk-in_closet.jpg','07a_Master_bathroom_1.jpg','08_Hallway_Bathroom.jpg' ]
      },
      {
        id: '1117Fairview',
        sold: true,
        title: '1117 Fairview Av, Arcadia 91007',
        price: '848000',
        soldDate: '2018-06-04',
        soldPrice: '850000',
        bedroom: '3',
        bathroom: '3',
        livingArea: '2041',
        lotSize: '',
        yearBuild: '2002',
        pics: ["MLS_03.jpg","MLS_07.jpg", "MLS_12.jpg", "MLS_17.jpg", "MLS_19.jpg", "MLS_24.jpg", "MLS_28.jpg","MLS_29.jpg" ]
      },
      {
        id: '2406S4th',
        sold: true,
        title: '2406 S 4th, Arcadia, CA 91007',
        price: '',
        soldDate: '',
        soldPrice: '1180000',
        bedroom: '3',
        bathroom: '3',
        livingArea: '1995',
        lotSize: '15597',
        yearBuild: '1951',
        pics: ['01_House_front.jpg','01_Living_room.jpg','02_Dining_area_1.jpg','03_Kitchen_1.jpg','04_Family_room.jpg','05_Master_bedroom_1.jpg','05a_Master_bathroom.jpg','07_Drive_way.jpg']
      },
      {
        id: '513WCommonwealth',
        sold: true,
        title: '513 W Commonwealth Ave, Alhambra, CA 91801',
        price: '',
        soldDate: '2018-05-10',
        soldPrice: '550000',
        bedroom: '2',
        bathroom: '1',
        livingArea: '878',
        lotSize: '2446',
        yearBuild: '1954',
        pics: ['00_Front.jpg','00a_FrontYard.jpg', '01_Livingroom_1.jpg', '02_Diningarea.jpg','03_Kitchen.jpg','03_Kitchen_1.jpg','04_Bedroom_2.jpg','05_Bedroom_1.jpg','06_Bathroom.jpg','07_Laundryroom.jpg','08_Side_yard.jpg']
      },
      {
        id: '1001Loma',
        sold: true,
        title: '1001 Loma Verde St, Monterey Park CA 91754',
        price: '',
        soldDate: '2018-02-28',
        soldPrice: '700000',
        bedroom: '3',
        bathroom: '2',
        livingArea: '1231',
        lotSize: '',
        yearBuild: '1948',
        pics: ['00_House_Front.jpg','01_Living_room.jpg','02_Dining_oom.jpg','04_Master_bedroom_1.jpg','06_Bathroom.jpg','09_Drive_way.jpg','09a_Backyard_2.jpg']
      },
      {
        id: '2616Grand',
        sold: true,
        title: '2616 W Grand Ave., #A, Alhambra, CA 91801',
        price: '',
        soldDate: '2018-03-02',
        soldPrice: '565000',
        bedroom: '3',
        bathroom: '2.5',
        livingArea: '1374',
        lotSize: '',
        yearBuild: '1983',
        pics: ['00_Front_1.jpg','00a_Front_door.jpg','01_Entry_1.jpg','01_Living_room.jpg','02_Dining_room_1.jpg','03_Kitchen_1.jpg','05_Master_bedroom.jpg','05a_Master_batrhoom.jpg']
      },
      {
        id: '8375Village',
        sold: true,
        title: '8375 Village Ln, Rosemead, CA 91770',
        price: '',
        soldDate: '2018-02-15',
        soldPrice: '539988',
        bedroom: '3',
        bathroom: '3',
        livingArea: '1829',
        lotSize: '',
        yearBuild: '1979',
        pics: ['00_Front_1.jpg','01_Living_room.jpg','02_Dining_room.jpg','03_Kitchen_1.jpg','05_Master_bedroom_1.jpg','05a_Master_bathroom.jpg','06_2nd_bedroom_with_view.jpg','06_View_from_bedroom.jpg','07_Enclosed_front_patio.jpg','07_Tennis_court.jpg','07a_Community_Pool.jpg']
      },
      {
        id: '201laFrance',
        sold: true,
        title: '201 La France Ave., #A, CA 91801',
        price: '605000',
        soldDate: '2018-04-13',
        soldPrice: '980000',
        bedroom: '3',
        bathroom: '3',
        livingArea: '1445',
        lotSize: '',
        yearBuild: '1987',
        pics: ['MLS_01.jpg','MLS_08.jpg','MLS_14.jpg','MLS_15.jpg','MLS_19.jpg','MLS_22.jpg']
      },
      {
        id: '8617EBroadway',
        sold: true,
        title: '8617 E Broadway., San Gabriel, CA 91776',
        price: '998000',
        soldDate: '2018-01-22',
        soldPrice: '980000',
        bedroom: '5',
        bathroom: '4.5',
        livingArea: '2838',
        lotSize: '6889',
        yearBuild: '2006',
        pics: ['MLS_02.jpg','MLS_08.jpg','MLS_12.jpg','MLS_19.jpg','MLS_36.jpg','MLS_40.jpg','MLS_43.jpg']
      },
      {
        id: '617NAlhambra',
        sold: true,
        title: '617 N Alhambra Ave., #G, Monterey Park CA 91755',
        price: '545000',
        soldDate: '2018-08-16',
        soldPrice: '',
        bedroom: '3',
        bathroom: '3',
        livingArea: '1177',
        lotSize: '',
        yearBuild: '1973',
        pics: ['00_Complex.jpg','01_Entrance.jpg','02_Living_room_1.jpg','03_Dining_area_1.jpg','04_Kitchen.jpg','06_Master_bedroom.jpg','06a_Master_bathroom.jpg','07_Bedroom_1.jpg','08_Patio.jpg']
      },
      {
        id: '6320CalleElegante',
        sold: true,
        title: '6320 Calle Elegante, Rancho Cucamonga, CA 91737',
        price: '598000',
        soldDate: '2017-12-05',
        soldPrice: '615000',
        bedroom: '4',
        bathroom: '3.5',
        livingArea: '2567',
        lotSize: '9600',
        yearBuild: '1992',
        pics: ['Front_view.jpg','Living_room.jpg','Dining_room.jpg','Kitchen.jpg','Master_bedroom.jpg','Master_bathroom.jpg','Back_yard.jpg','Back_yard.jpg']
      },
      {
        id: '1131Hare',
        sold: true,
        title: '1131 Hare Ave., Walnut, CA 91789',
        price: '779000',
        soldDate: '2017-12-05',
        soldPrice: '805000',
        bedroom: '4',
        bathroom: '4',
        livingArea: '2145',
        lotSize: '8178',
        yearBuild: '1965',
        pics: ['MLS_01.jpg','MLS_12.jpg','MLS_17.jpg','MLS_21.jpg','MLS_36.jpg','MLS_37.jpg']
      },
      {
        id: '1015Arcadia',
        sold: true,
        title: '1015 Arcadia Ave.,#19,  Arcadia, CA 91007',
        soldPrice: '589000',
        soldDate: '2017-11-16',
        bedroom: '2',
        bathroom: '2',
        livingArea: '1505',
        lotSize: '',
        yearBuild: '1974',
        pics: ['00_Complex.jpg','02_Downstaris_bedroom.jpg','03_Livingroom_2.jpg','06_Kitchen.jpg','07_Master_bedroom.jpg','07a_Master_Bathroom.jpg','08_Enclosed_patio.jpg','09_Complex_courtyard.jpg']
      },
      {
        id: '316NFirst',
        sold: true,
        title: '316 N. First St.,#4, Alhambra, CA 91801',
        soldPrice: '518000',
        bedroom: '3',
        bathroom: '2.5',
        livingArea: '1401',
        yearBuild: '1982',
        pics: ['MLS_03.jpg','MLS_06.jpg','MLS_10.jpg','MLS_12.jpg','MLS_20.jpg','MLS_24.jpg']
      },
      {
        id: '100Electric',
        sold: true,
        title: '100 Electric Ave, #17  Alhambra, CA 91801',
        soldPrice: '515000',
        soldDate: '2017-10-27',
        bedroom: '2',
        bathroom: '2.5',
        livingArea: '1264',
        lotSize: '',
        yearBuild: '1982',
        pics: ['00_Front.jpg','01_Livingroom_Dining_room.jpg','03_Kitchen_2.jpg','05_Master_bedroom.jpg','05a_Master_bathroom.jpg','08_Building.jpg','08_Pool.jpg']
      },
      {
        id: '428NChapel',
        sold: true,
        title: '428 N Chapel Ave., #D, Alhambra 91801',
        soldPrice: '455000',
        soldDate: '2017-07-26',
        bedroom: '2',
        bathroom: '2',
        livingArea: '995',
        yearBuild: '1991',
        pics: ['00_Exterior_1.jpg','02_Livingroom_Dining_Area.jpg','04_Kitchen.jpg','05_Bathroom_Downstairs.jpg','06_Bedroom_1.jpg']
      },
      {
        id: '885SOrangeGrove',
        sold: true,
        title: '885 S Orange Grove Bl # 6, Pasadena 91105',
        soldPrice: '1189000',
        soldDate: '2017-08-18',
        bedroom: '3',
        bathroom: '2.5',
        livingArea: '2455',
        yearBuild: '1973',
        pics: ['Full_01.jpg','Full_03.jpg','Full_06.jpg','Full_11.jpg','Full_21.jpg','Full_26.jpg','Full_30.jpg','Full_37.jpg']
      },
      {
        id: '811Rollinst',
        sold: true,
        title: '811 Rollin St, South Pasadena, CA 91030',
        soldPrice: '1370000',
        soldDate: '2017-06-28',
        bedroom: '4',
        bathroom: '3',
        livingArea: '3174',
        lotSize: '13724',
        yearBuild: '1990',
        url: 'http://www.811rollinst.com',
        pics: ['Rollinst1.jpg']
      },
      {
        id: '105EBeaconA',
        sold: true,
        title: '105 E Beacon St # A, Alhambra 91801',
        soldDate: '2017-05-26',
        soldPrice: '541000',
        bedroom: '3',
        bathroom: '2.5',
        livingArea: '1146',
        yearBuild: '1989',
        pics: ['Full_02.jpg','Full_10.jpg','Full_16.jpg','Full_26.jpg','Full_27.jpg']
      },
      {
        id: '1701Cedar',
        sold: true,
        title: '1701 Cedar St # 2, Alhambra 91801 ',
        soldPrice: '520000',
        soldDate: '2017-05-19',
        bedroom: '3',
        bathroom: '2.5',
        livingArea: '1350',
        yearBuild: '1984',
        pics: ['Full_02.jpg','Full_08.jpg','Full_16.jpg','Full_27.jpg','30.jpg']
      },
      {
        id: '411SGarfield',
        sold: true,
        title: '411 S Garfield Ave., #42, Monterey Park, CA 91754',
        soldDate: '2017-05-18',
        soldPrice: '310000',
        bedroom: '1',
        bathroom: '1',
        livingArea: '721',
        lotSize: '',
        yearBuild: '2007',
        youtube: 'https://www.youtube.com/watch?v=pFqNjFLqcmI',
        youtube_zh: 'https://www.youtube.com/watch?v=pFqNjFLqcmI',
        youtubePic: 'youtube.jpg',
        pics: ['00_Complex Exterior_1.jpg','01_Livingroom_2.jpg','03_Kitchen.jpg','04_Bedroom_3.jpg','06_Recreation room.jpg','06_Recreation room_2.jpg','07_Complex.jpg','07_Complex_2.jpg','08_Driveway.jpg']
      },

      {
        id: '89Commonwealth',
        sold: true,
        title: '89 Commonwealth Ave., #3c, Alhambra CA 91801',
        soldDate: '2017-03-30',
        soldPrice: '428000',
        bedroom: '1',
        bathroom: '1',
        livingArea: '990',
        lotSize: '',
        yearBuild: '2006',
        youtube: 'https://www.youtube.com/watch?v=k0KGqt7FAtw&t=5s',
        youtube_zh: 'https://www.youtube.com/watch?v=knkm7-kR330',
        youtubePic: 'Full_01_V.jpg',
        pics: ['Full_01.jpg', 'Full_28.jpg','Full_07.jpg','Full_10.jpg','Full_18.jpg','Full_23.jpg']
      },
      {
        id: '617EAngeleno',
        sold: true,
        title: '617 E Angeleno Av # 303, Burbank 91501',
        price: '',
        soldDate: '2017-04-11',
        soldPrice: '440000',
        bedroom: '2',
        bathroom: '2',
        livingArea: '1138',
        yearBuild: '1969',
        pics: ['Full_02.jpg', 'Full_09.jpg','Full_14.jpg','Full_21.jpg','Full_22.jpg','Full_28.jpg']
      },
      {
        id: '786Banyan',
        sold: true,
        title: '786 Banyan Way, Pomona, CA 91767',
        price: '',
        soldDate: '2017-03-08',
        soldPrice: '480000',
        bedroom: '3',
        bathroom: '3',
        livingArea: '1850',
        lotSize: '',
        yearBuild: '2017',
        pics: ['00_Front.JPG','01_Downstairs_Loft.JPG','01_Downstairs_Loft_1.JPG','02_Living_room_Dining_room.JPG','02_Living_room_Dining_room.JPG','03_Kitchen.JPG','04_Master_bedroom.JPG','05_Master_bathroom.JPG','05_Master_bathroom_1.JPG','05_Master_bedroom_Walk-in_closet.JPG','06_Bedroom.JPG','06a_Hallway_bathroom.JPG','07_Patio.JPG','08_BBQ_area.JPG','08_Playground.JPG']
      },
      {
        id: '1312Elm',
        sold: true,
        title: '1312 Elm St, Alhambra, CA 91083',
        soldDate: '2017-02-10',
        soldPrice: '584000',
        bedroom: '2',
        bathroom: '1',
        livingArea: '1034',
        lotSize: '6616',
        yearBuild: '1942',
        pics: ['MLS_02.jpg','MLS_07.jpg','MLS_16.jpg','MLS_25.jpg','MLS_29.jpg','MLS_42.jpg']
      },
      {
        id: '2431south3rd',
        sold: true,
        title: '2431 S 3rd Ave, Arcadia, CA 91006',
        soldDate: '2016-11-01',
        soldPrice: '2700000',
        bedroom: '5',
        bathroom: '6',
        livingArea: '6782',
        lotSize: '15386',
        yearBuild: '2009',
        pics: ['Front.jpg','Livingroom.jpg','Office.jpg','Kitchen.jpg','Master_bedroom.jpg','Master_bathroom.jpg','Back_yard.jpg']
      },
      {
        id: '545LaPaz',
        sold: true,
        title: '545 La Paz Dr, San Marno, CA 91108',
        soldDate: '2016-06-27',
        soldPrice: '1995000',
        bedroom: '3',
        bathroom: '2',
        livingArea: '2732',
        yearBuild: '1927',
        pics: ['LaPaz1.jpg', 'LaPaz2.jpg', 'LaPaz3.jpg', 'LaPaz4.jpg', 'LaPaz5.jpg', 'LaPaz6.jpg']
      },
      {
        id: '725Plymouth',
        sold: true,
        title: '725 Plymouth Rd, San Marno, CA 91108',
        soldDate: '2016-07-13',
        soldPrice: '2380000',
        bedroom: '4',
        bathroom: '3',
        livingArea: '2943',
        yearBuild: '1928',
        pics: ['Plymouth6.jpg', 'Plymouth2.jpg', 'Plymouth3.jpg', 'Plymouth4.jpg', 'Plymouth5.jpg', 'Plymouth1.jpg']
      },
      {
        id: '1145RosalindSanMarino',
        sold: true,
        title: '1145 Rosalind Rd, San Marino, CA 91108',
        soldDate: '2015-08-28',
        soldPrice: '5300000',
        bedroom: '6',
        bathroom: '7',
        livingArea: '4605',
        lotSize: '37900',
        yearBuild: '1953',
        pics: ['Rosalind0.jpg', 'Rosalind1.jpg', 'Rosalind2.jpg', 'Rosalind8.jpg', 'Rosalind4.jpg', 'Rosalind5.jpg']
      },
      {
        id: '8WNorman',
        sold: true,
        title: '8 W. Norman Ave, Arcadia CA 91006',
        soldDate: '2015-06-16',
        soldPrice: '2700000',
        bedroom: '5',
        bathroom: '6',
        livingArea: '5616',
        lotSize: '13476',
        yearBuild: '2014',
        pics: ['1_8WNorman.jpg','2_8WNorman.jpg','3_8WNorman.jpg','4_8WNorman.jpg','5_8WNorman.jpg','6_8WNorman.jpg','7_8WNorman.jpg']
      },
      {
        id: '3010ESunsetHill',
        sold: true,
        title: '3010 E Sunset Hill Dr, West Covina, CA 91791',
        price: '918000',
        soldDate: '2016-09-27',
        soldPrice: '850000',
        bedroom: '4',
        bathroom: '4',
        livingArea: '3157',
        lotSize: '17480',
        yearBuild: '1984',
        pics: ['sunsethill1.jpg','Housefront.jpg','Livingroom.jpg','Kitchen.jpg','Masterbathroom.jpg','Masterbedroom.jpg','BackPatio.jpg','BackYard.jpg']
      },
      {
        id: '2150FultonAve',
        sold: true,
        title: '2150 Fulton Ave, Monterey Park, CA 91755',
        price: '',
        soldDate: '2016-09-30',
        soldPrice: '580000',
        bedroom: '3',
        bathroom: '1',
        livingArea: '1056',
        lotSize: '12122',
        yearBuild: '1949',
        pics: ['2150FultonAve1.jpg','2150FultonAve2.jpg','2150FultonAve3.jpg','2150FultonAve4.jpg','2150FultonAve5.jpg','2150FultonAve6.jpg']
      },
      {
        id: '39Fano',
        sold: true,
        title: '39 Fano St., #C, Arcadia, CA 91007',
        soldDate: '2016-02-03',
        soldPrice: '750000',
        bedroom: '3',
        bathroom: '3',
        livingArea: '1890',
        lotSize: '',
        yearBuild: '2002',
        pics: ['39Fano1.jpg','39Fano2.jpg','39Fano3.jpg','39Fano4.jpg','39Fano5.jpg']
      },
      {
        id: '521Arbolada',
        sold: true,
        title: '521 Arbolada Dr, Arcadia, CA 91006',
        soldDate: '2015-04-23',
        soldPrice: '2450000',
        bedroom: '4',
        bathroom: '4',
        livingArea: '3282',
        lotSize: '20941',
        yearBuild: '1951',
        pics: ['Arbolada1.jpg','Arbolada2.jpg','Arbolada3.jpg','Arbolada4.jpg','Arbolada5.jpg','Arbolada6.jpg','Arbolada7.jpg']
      },
      {
        id: '5762Ridgeview',
        sold: true,
        title: '5762 Ridgeview Dr, La Verne Ca 91750',
        soldDate: '2015-08-06',
        soldPrice: '982000',
        bedroom: '4',
        bathroom: '3',
        livingArea: '3160',
        lotSize: '9019',
        yearBuild: '1997',
        pics: ['Ridgeview1.jpg','Ridgeview2.jpg','Ridgeview3.jpg','Ridgeview4.jpg','Ridgeview5.jpg','Ridgeview6.jpg']
      },
      {
        id: '451Woodruff',
        sold: true,
        title: '451 W Woodruff Ave., Arcadia, CA 91007',
        soldDate: '2015-08-31',
        soldPrice: '2378000',
        bedroom: '6',
        bathroom: '5',
        livingArea: '5352',
        lotSize: '12831',
        yearBuild: '1997',
        pics: ['451Woodruff1.jpg','451Woodruff2.jpg','451Woodruff3.jpg','451Woodruff4.jpg','451Woodruff5.jpg']
      },
      {
        id: '310W',
        sold: false,
        title: '310 W Wooward Ave., # B, Alhambra, CA 91801',
        price: '548000',
        soldDate: '2018-08-29',
        soldPrice: '',
        bedroom: '3',
        bathroom: '3',
        livingArea: '1911',
        lotSize: '',
        yearBuild: '1987',
        pics: ['MLS_02.jpg', 'MLS_08.jpg', 'MLS_13.jpg', 'MLS_16.jpg', 'MLS_27.jpg', 'MLS_29.jpg']
      },
      {
        id: '228Monterey',
        sold: true,
        title: '228 Monterey Rd., #F, South Pasadena, CA 91030',
        soldDate: '2015-12-18',
        soldPrice: '515000',
        bedroom: '2',
        bathroom: '3',
        livingArea: '1121',
        lotSize: '',
        yearBuild: '1985',
        pics: ['228Monterey1.jpg','228Monterey2.jpg','228Monterey3.jpg','228Monterey4.jpg','228Monterey5.jpg']
      },
      {
        id: '856SMarengo',
        sold: true,
        title: '856 S Marengo Ave, #3, Pasadena CA91106',
        soldDate: '2015-01-04',
        soldPrice: '680500',
        bedroom: '3',
        bathroom: '3',
        livingArea: '1413',
        lotSize: '',
        yearBuild: '1998',
        pics: ['856SMarengo1.jpg','856SMarengo2.jpg','856SMarengo3.jpg','856SMarengo4.jpg','856SMarengo5.jpg','856SMarengo6.jpg']
      },
      {
        id: '392SMarengo',
        sold: true,
        title: '392 S. Marengo Ave., #108, CA 91101',
        soldDate: '2015-03-26',
        soldPrice: '697500',
        bedroom: '4',
        bathroom: '3',
        livingArea: '1924',
        lotSize: '',
        yearBuild: '1993',
        pics: ['392SMarengo1.jpg','392SMarengo2.jpg','392SMarengo3.jpg','392SMarengo4.jpg','392SMarengo5.jpg']
      },
      {
        id: '375Grand',
        sold: true,
        title: '375 Grand Ave, Monrovia, CA 91016',
        soldDate: '2015-02-24',
        soldPrice: '860000',
        bedroom: '3',
        bathroom: '3',
        livingArea: '1632',
        lotSize: '7486',
        yearBuild: '1957',
        pics: ['375Grand1.jpg','375Grand2.jpg','375Grand3.jpg','375Grand4.jpg','375Grand5.jpg','375Grand6.jpg']
      },
      {
        id: '1130Arcadia',
        sold: true,
        title: '1130 Arcadia Ave., #C, Arcadia CA 91007',
        soldDate: '2015-03-26',
        soldPrice: '538000',
        bedroom: '2',
        bathroom: '2',
        livingArea: '1390',
        lotSize: '',
        yearBuild: '1971',
        pics: ['1130Arcadia1.jpg','1130Arcadia2.jpg','1130Arcadia3.jpg','1130Arcadia4.jpg','1130Arcadia5.jpg']
      },
      {
        id: '620TheVillage',
        sold: true,
        title: '620 The Village, #312, Redondo Beach, CA 90277',
        soldDate: '2015-03-27',
        soldPrice: '540000',
        bedroom: '1',
        bathroom: '1',
        livingArea: '619',
        lotSize: '',
        yearBuild: '1974',
        pics: ['620TheVillage1.jpg','620TheVillage2.jpg','620TheVillage3.jpg','620TheVillage4.jpg','620TheVillage5.jpg']
      },
      {
        id: '366CaminoDelSol',
        sold: true,
        title: '366 Camino Del Sol, South Pasadena CA 91030',
        soldDate: '2015-01-30',
        soldPrice: '1586000',
        bedroom: '4',
        bathroom: '4',
        livingArea: '3613',
        lotSize: '7962',
        yearBuild: '1965',
        pics: ['1_366CaminoDelSol.jpg','2_366CaminoDelSol.jpg','3_366CaminoDelSol.jpg','4_366CaminoDelSol.jpg','5_366CaminoDelSol.jpg','6_366CaminoDelSol.jpg']
      },
      {
        id: '10015ViaPescadero',
        sold: true,
        title: '10015 Via Pescadero, Moreno Valley, CA 92557',
        soldDate: '2016-08-24',
        soldPrice: '399000',
        bedroom: '5',
        bathroom: '3',
        livingArea: '2917',
        lotSize: '',
        yearBuild: '2004',
        pics: ['Pescadero0.jpg','Pescadero1.jpg','Pescadero2.jpg','Pescadero3.jpg','Pescadero4.jpg']
      },
      {
        id: '2849Weidermeyer',
        sold: true,
        title: '2849 Weidermeyer Ave. Arcadia CA 91006',
        soldDate: '2016-08-23',
        soldPrice: '510000',
        bedroom: '3',
        bathroom: '1',
        livingArea: '1042',
        lotSize: '',
        yearBuild: '1949',
        pics: ['Weidermeyer0.jpg','Weidermeyer1.jpg','Weidermeyer2.jpg','Weidermeyer3.jpg','Weidermeyer4.jpg','Weidermeyer5.jpg']
      },
      {
        id: '1020marengo',
        sold: true,
        title: '1020 S Marengo Ave #8, Alhambra, CA 91803',
        soldDate: '2016-08-16',
        soldPrice: '388000',
        price: '388000',
        bedroom: '3',
        bathroom: '2.5',
        livingArea: '1220',
        lotSize: '',
        yearBuild: '1984',
        url: 'http://www.1020marengo.com/',
        pics: ['marengo1.jpg','marengo2.jpg','marengo3.jpg','marengo4.jpg','marengo5.jpg','marengo6.jpg']
      },

      {
        id: '1822WGarveyAveAlhambra',
        sold: true,
        title: '1822 W. Garvey Ave., Alhambra, CA 91803',
        soldDate: '2016-07-22',
        soldPrice: '455000',
        bedroom: '2',
        bathroom: '3',
        livingArea: '1409',
        yearBuild: '1980',
        pics: ['1822WGarvey1.jpg','1822WGarvey2.jpg','1822WGarvey3.jpg','1822WGarvey4.jpg','1822WGarvey5.jpg','1822WGarvey6.jpg',]
      },
      {
        id: 'Walnut525Southcoast',
        sold: true,
        title: '525 Southcoast Dr, Walnut, CA 91789',
        price: '698000',
        soldDate : '2016-07-28',
        soldPrice: '670000',
        bedroom: '4',
        bathroom: '2',
        livingArea: '2276',
        lotSize: '8648',
        yearBuild: '1975',
        pics: ['Walnut525Southcoast1.jpg', 'Walnut525Southcoast2.jpg', 'Walnut525Southcoast3.jpg', 'Walnut525Southcoast4.jpg', 'Walnut525Southcoast5.jpg']
      },
      {
        id: '1908CedarAlhambra',
        sold: true,
        title: '1908 Cedar St, Alhambra, CA 91801',
        price: '398000',
        soldDate : '2016-06-30',
        soldPrice: '415000',
        bedroom: '2',
        bathroom: '2',
        livingArea: '905',
        lotSize: '',
        yearBuild: '1994',
        pics: ['Cedar1.jpg','Cedar4.jpg','Cedar6.jpg','Cedar8.jpg','Cedar7.jpg','Cedar9.jpg']
      },
      {
        id: 'Arcadia804caminoreal',
        sold: true,
        title: '804 W Camino Real Ave, Arcadia, CA 91007',
        soldDate: '2016-05-11',
        soldPrice: '625000',
        price: '658000',
        bedroom: '2',
        bathroom: '1',
        livingArea: '782',
        lotSize: '5658',
        yearBuild: '',
        url: 'http://www.804caminoreal.com/',
        pics: ['caminoreal1.jpg','caminoreal2.jpg','caminoreal3.jpg','caminoreal4.jpg','caminoreal5.jpg','caminoreal6.jpg']
      },
      {
        id: 'Alhambra2721WShorb',
        sold: true,
        title: '2721 W. Shorb Street, Alhambra',
        soldPrice: '495000',
        bedroom: '2',
        bathroom: '2',
        livingArea: '996',
        lotSize: '4589',
        yearBuild: '',
        url: 'http://www.2721shorb.com/',
        pics: ['WShorb1.jpg','WShorb2.jpg','WShorb3.jpg','WShorb4.jpg','WShorb5.jpg','WShorb6.jpg','WShorb7.jpg']
      },
      {
        id: '1820garvey',
        sold: true,
        title: '1820 Garvey Ave #3, Alhambra CA 91803',
        soldDate: '2016-04-12',
        soldPrice: '448000',
        bedroom: '3',
        bathroom: '2.5',
        livingArea: '1498',
        lotSize: '',
        yearBuild: '1980',
        url: 'http://www.1820garvey.com/',
        pics: ['01_Livingroom.jpg', '02_Dining.jpg', '03_Master-bedroom.jpg', '04_Bedroom.jpg', '05_Bonus-Room-garage.jpg', '00_Community.jpg']
      },
      {
        id: '116chapel',
        sold: true,
        title: '116 S Chapel Ave, Alhambra, CA 91801',
        soldDate: '2016-04-13',
        soldPrice: '456000',
        bedroom: '2',
        bathroom: '2.5',
        livingArea: '1313',
        url: 'http://www.116chapel.com/',
        pics: ['1_116chapel.jpg', '2_116chapel.jpg', '3_116chapel.jpg', '4_116chapel.jpg', '6_116chapel.jpg', '5_116chapel.jpg']
      },
      {
        id: '71bonnieave',
        sold: true,
        title: '71 N Bonnie Ave #1, Pasadena, CA',
        soldDate: '2016-04-26',
        soldPrice: '780000',
        listingPrice: '795000',
        bedroom: '3',
        bathroom: '2.5',
        livingArea: '1637',
        lotSize: '8030',
        yearBuild: '2012',
        url: 'http://www.71bonnieave.com/',
        pics: ['1_71bonnieave.jpg', '2_71bonnieave.jpg', '3_71bonnieave.jpg', '4_71bonnieave.jpg', '5_71bonnieave.jpg', '6_71bonnieave.jpg']
      },
      {
        id: '885orangegrove',
        sold: true,
        title: '885 S. Orange Grove Blvd., #6, Pasadena, CA 91105',
        soldDate: '2016-10-02',
        soldPrice: '924000',
        bedroom: '3',
        bathroom: '3',
        livingArea: '2544',
        lotSize: '',
        yearBuild: '1973',
        pics: ['orangegrove0.jpg', 'orangegrove1.jpg', 'orangegrove2.jpg', 'orangegrove3.jpg', 'orangegrove4.jpg', 'orangegrove5.jpg']
      },
      {
        id: 'Covina758ELevel',
        sold: true,
        title: '758 E. Level St, Covina, CA 91723',
        soldDate: '2016-04-01',
        soldPrice: '498000',
        bedroom: '3',
        bathroom: '2',
        livingArea: '1537',
        lotSize: '8334',
        yearBuild: '1960',
        pics: ['Convina1.jpg', 'Convina2.jpg', 'Convina3.jpg', 'Convina4.jpg', 'Convina5.jpg', 'Convina6.jpg']
      },
      {
        id: 'Arcadia325California',
        sold: true,
        title: '325 California St. #B. Arcadia, CA 91006',
        soldDate: '2016-2-29',
        soldPrice: '895000',
        bedroom: '4',
        bathroom: '3',
        livingArea: '2187',
        lotSize: '',
        yearBuild: '2000',
        pics: ['California1.jpg', 'California2.jpg', 'California3.jpg', 'California4.jpg', 'California5.jpg']
      },
      {
        id: '831stoneman',
        sold: true,
        title: '831 South Stoneman Ave.,# A, Alhambra CA 91801',
        soldDate: '2016-02-16',
        soldPrice: '518000',
        bedroom: '3',
        bathroom: '3',
        livingArea: '1660',
        lotSize: '',
        yearBuild: '1991',
        pics: ['stoneman0.jpg', 'stoneman1.jpg', 'stoneman2.jpg', 'stoneman3.jpg', 'stoneman4.jpg']
      },
      {
        id: '3542WillowGlen',
        sold: true,
        title: '3542 Willow Glen Ln, West Covina, CA 91792',
        soldDate: '2016-01-29',
        soldPrice: '660000',
        bedroom: '4',
        bathroom: '3',
        livingArea: '2215',
        lotSize: '4051',
        yearBuild: '2005',
        pics: ['WillowGlen1.jpg', 'WillowGlen2.jpg', 'WillowGlen3.jpg', 'WillowGlen4.jpg', 'WillowGlen5.jpg', 'WillowGlen6.jpg']
      },
      {
        id: '13949DoveCanyon',
        sold: true,
        title: '13949 Dove Canyon Way, Rancho Cucamonga, CA 91739',
        soldDate: '2016-01-29',
        soldPrice: '515000',
        bedroom: '4',
        bathroom: '3',
        livingArea: '2378',
        lotSize: '6025',
        yearBuild: '2006',
        pics: ['DoveCanyon0.jpg', 'DoveCanyon1.jpg', 'DoveCanyon2.jpg', 'DoveCanyon3.jpg', 'DoveCanyon4.jpg', 'DoveCanyon5.jpg']
      },
      {
        id: '4625Michigan',
        sold: true,
        title: '4625 Michigan Ave, Los Angeles, CA 90022',
        soldDate: '2016-07-26',
        soldPrice: '510000',
        bedroom: '2',
        bathroom: '1',
        livingArea: '1795',
        lotSize: '',
        yearBuild: '1961',
        pics: ['Michigan1.jpg', 'Michigan2.jpg', 'Michigan3.jpg', 'Michigan4.jpg', 'Michigan5.jpg']
      },
      {
        id: '1103alhambra',
        sold: true,
        title: '1103 Alhambra, San Gabriel, CA 91775',
        soldDate: '2015-11-24',
        soldPrice: '792000',
        bedroom: '3',
        bathroom: '3',
        livingArea: '2765',
        lotSize: '6280',
        yearBuild: '1940',
        pics: ['1103Alhambra1.jpg', '1103Alhambra2.jpg', '1103Alhambra3.jpg', '1103Alhambra4.jpg', '1103Alhambra5.jpg', '1103Alhambra6.jpg']
      },
      {
        id: 'Monterey1052SGarfield',
        sold: true,
        title: '1052 S. Garfield Ave, Monterey Park, CA 91754',
        soldDate: '2015-11-20',
        soldPrice: '440000',
        bedroom: '3',
        bathroom: '3',
        livingArea: '1536',
        lotSize: '1131',
        yearBuild: '1981',
        pics: ['Garfield1.jpg', 'Garfield2.jpg', 'Garfield3.jpg', 'Garfield4.jpg', 'Garfield5.jpg']
      },
      {
        id: 'Alhambra1715Westmont',
        sold: true,
        title: '1715 Westmont Drive, Alhambra CA 91803',
        soldDate: '2015-11-10',
        soldPrice: '570000',
        bedroom: '3',
        bathroom: '2',
        livingArea: '1283',
        lotSize: '4800',
        yearBuild: '1954',
        pics: ['Westmont1.jpg', 'Westmont2.jpg', 'Westmont3.jpg', 'Westmont4.jpg', 'Westmont5.jpg']
      },
      {
        id: '1915Sycamore',
        sold: true,
        title: '1915 Sycamore Dr, San Marino, CA 91108',
        soldDate: '2015-10-27',
        soldPrice: '1450000',
        bedroom: '3',
        bathroom: '2',
        livingArea: '2255',
        lotSize: '8698',
        yearBuild: '1940',
        pics: ['1_1915Sycamore.jpg', '2_1915Sycamore.jpg', '3_1915Sycamore.jpg', '4_1915Sycamore.jpg', '5_1915Sycamore.jpg']
      },
      {
        id: '1652LaGolondrianAve',
        sold: true,
        title: '1652 La Golondrian Ave, Alhambra CA 91803',
        soldDate: '2015-10-07',
        soldPrice: '610000',
        bedroom: '2',
        bathroom: '2',
        livingArea: '1584',
        lotSize: '4787',
        yearBuild: '1930',
        pics: ['1_1652LaGolondrianAve.jpg', '2_1652LaGolondrianAve.jpg', '3_1652LaGolondrianAve.jpg', '4_1652LaGolondrianAve.jpg', '5_1652LaGolondrianAve.jpg']
      },
      {
        id: '15407Memphis',
        sold: true,
        title: '15407 Memphis Dr, Fontana, CA 92336',
        soldDate: '2015-11-05',
        soldPrice: '395000',
        bedroom: '4',
        bathroom: '3',
        livingArea: '2440',
        lotSize: '5000',
        yearBuild: '2002',
        pics: ['1_15407Memphis.jpg', '2_15407Memphis.jpg', '3_15407Memphis.jpg', '4_15407Memphis.jpg', '5_15407Memphis.jpg']
      },
      {
        id: '126WLeRoyAve',
        sold: true,
        title: '126 W LeRoy Ave, Arcadia, CA 91007',
        soldDate: '2015-11-03',
        soldPrice: '975000',
        bedroom: '3',
        bathroom: '2',
        livingArea: '1756',
        lotSize: '7371',
        yearBuild: '1946',
        pics: ['1_126WLeRoyAve.jpg', '2_126WLeRoyAve.jpg', '3_126WLeRoyAve.jpg', '4_126WLeRoyAve.jpg', '5_126WLeRoyAve.jpg']
      },
      {
        id: '935Ackley',
        sold: true,
        title: '935 Ackley St, Monterey Park, CA 91755',
        soldDate: '2015-07-17',
        soldPrice: '555000',
        bedroom: '3',
        bathroom: '2',
        livingArea: '1332',
        lotSize: '6272',
        yearBuild: '1961',
        pics: ['1_935Ackley.jpg', '2_935Ackley.jpg', '3_935Ackley.jpg', '4_935Ackley.jpg', '5_935Ackley.jpg']
      },
      {
        id: '513WCommonwealth',
        sold: true,
        title: '513 W. Commonwealth Ave., Alhambra, CA 91801',
        soldDate: '2015-07-28',
        soldPrice: '443000',
        bedroom: '2',
        bathroom: '1',
        livingArea: '898',
        lotSize: '2446',
        yearBuild: '1954',
        pics: ['1_513WCommonwealth.jpg', '2_513WCommonwealth.jpg', '3_513WCommonwealth.jpg', '4_513WCommonwealth.jpg', '5_513WCommonwealth.jpg']
      },
      {
        id: '105EBeacon',
        sold: true,
        title: '105  E Beacon St., #B. Alhambra, CA 91801',
        soldDate: '2015-07-07',
        soldPrice: '443000',
        bedroom: '3',
        bathroom: '2',
        livingArea: '1350',
        lotSize: '',
        yearBuild: '1989',
        pics: ['1_105EBeacon.jpg', '2_105EBeacon.jpg', '3_105EBeacon.jpg', '4_105EBeacon.jpg', '5_105EBeacon.jpg']
      },
      {
        id: '2104Westmont',
        sold: true,
        title: '2104 Westmont Dr., Alhambra, CA 91803',
        soldDate: '2015-07-24',
        soldPrice: '700000',
        bedroom: '4',
        bathroom: '4',
        livingArea: '1902',
        lotSize: '6674',
        yearBuild: '1953',
        pics: ['1_2104Westmont.jpg', '2_2104Westmont.jpg', '3_2104Westmont.jpg', '4_2104Westmont.jpg', '5_2104Westmont.jpg', '6_2104Westmont.jpg']
      },
      {
        id: '1002RoyalOaks',
        sold: true,
        title: '1002 Royal Oaks Dr., #B. Monrovia, CA 91016',
        soldDate: '2015-07-29',
        soldPrice: '530000',
        bedroom: '2',
        bathroom: '3',
        livingArea: '1901',
        lotSize: '',
        yearBuild: '1993',
        pics: ['1_1002RoyalOaks.jpg', '2_1002RoyalOaks.jpg', '3_1002RoyalOaks.jpg', '4_1002RoyalOaks.jpg', '5_1002RoyalOaks.jpg', '6_1002RoyalOaks.jpg']
      },
      {
        id: '308NMarguerita',
        sold: true,
        title: '308 N. Marguerita Ave., #E, Alhambra, CA 91801',
        soldDate: '2015-08-11',
        soldPrice: '462000',
        bedroom: '3',
        bathroom: '3',
        livingArea: '1245',
        lotSize: '',
        yearBuild: '1989',
        pics: ['1_308NMarguerita.jpg', '2_308NMarguerita.jpg', '3_308NMarguerita.jpg', '4_308NMarguerita.jpg', '5_308NMarguerita.jpg']
      },
      {
        id: '15SValencia',
        sold: true,
        title: '15 S. Valencia St. Alhambra, CA 91801',
        soldDate: '2015-09-10',
        soldPrice: '638000',
        bedroom: '3',
        bathroom: '2',
        livingArea: '1648',
        lotSize: '8400',
        yearBuild: '1929',
        pics: ['1_15SValencia.jpg']
      },
      {
        id: '1070HastingsRanch',
        sold: true,
        title: '1070 Hastings Ranch Dr, Pasadena, CA 91107',
        soldDate: '2015-06-04',
        soldPrice: '848000',
        bedroom: '3',
        bathroom: '3',
        livingArea: '1663',
        lotSize: '9438',
        yearBuild: '1951',
        pics: ['1_1070HastingsRanch.jpg','2_1070HastingsRanch.jpg','3_1070HastingsRanch.jpg','4_1070HastingsRanch.jpg','5_1070HastingsRanch.jpg','6_1070HastingsRanch.jpg']
      },
      {
        id: '12256Kneeland',
        sold: true,
        title: '12256 Kneeland Dr, Rancho Cucamonga, CA 91739',
        soldDate: '2015-03-25',
        soldPrice: '675000',
        bedroom: '5',
        bathroom: '3',
        livingArea: '3156',
        lotSize: '10424',
        yearBuild: '2004',
        pics: ['1_12256Kneeland.jpg','2_12256Kneeland.jpg','3_12256Kneeland.jpg','4_12256Kneeland.jpg','5_12256Kneeland.jpg']
      },
      {
        id: '503NAtlantic',
        sold: true,
        title: '503 N Atlantic Blvd., #B, Alhambra CA 91801',
        soldDate: '2015-03-12',
        soldPrice: '400000',
        bedroom: '2',
        bathroom: '3',
        livingArea: '1016',
        lotSize: '',
        yearBuild: '2000',
        pics: ['1_503NAtlantic.jpg','2_503NAtlantic.jpg','3_503NAtlantic.jpg','4_503NAtlantic.jpg','5_503NAtlantic.jpg']
      },
      {
        id: '1712Vine',
        sold: true,
        title: '1712 Vine St.,#B,  Alhambra, CA 91801',
        soldDate: '2015-03-10',
        soldPrice: '445000',
        bedroom: '3',
        bathroom: '2',
        livingArea: '1391',
        lotSize: '',
        yearBuild: '1995',
        pics: ['1_1712Vine.jpg','2_1712Vine.jpg','3_1712Vine.jpg','4_1712Vine.jpg','5_1712Vine.jpg']
      }
      //{id: '', sold:true, title:'', soldDate:'' soldPrice:'', bedroom:'', bathroom:'', livingArea:'', lotSize:'', yearBuild:'', pics:[]}
    ]
  }
}

export default soldPropertyStore
